import { exportConstants } from '../constants';

let savedExports = JSON.parse(localStorage.getItem('exports'));
const initialState = {
    isExportUpdated: true,

    exported: savedExports ? savedExports : null,

    exporting: false,
    exportingError: null,
};

export function exporting(state = initialState, action) {
    switch (action.type) {
        case exportConstants.EXPORT_DATA_REQUEST: {
            return {
                ...state,
                exporting: true,
                exported: null,
                exportingError: null,
            };
        }
        case exportConstants.EXPORT_DATA_SUCCESS: {
            return {
                ...state,
                exporting: false,
                exported: action.data,
                exportingError: null,
            };
        }
        case exportConstants.EXPORT_DATA_FAILURE: {
            return {
                ...state,
                exporting: false,
                exportingError: action.error,
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
}
